export default __webpack_public_path__ + "static/media/lisa1.a3c6d051.gif";